import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { DiscreteProgressBar } from 'src/components';


const useStyles = makeStyles(theme => ({
  barContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  icon: {
    color: theme.palette.common.gray600,
    marginRight: theme.spacing(2),
  },
  label: {
    minWidth: 200,
  },
}));

const DiscreteProgressBarGroup = ({ items = [], getSegments }) => {
  const classes = useStyles();
  return (
    <>
      {items.map((item, index) => (
        <Box key={index} className={classes.barContainer}>
          {item.icon && <Box className={classes.icon}>{item.icon}</Box>}
          <Typography variant="body2" className={classes.label}>{item.label}</Typography>
          <DiscreteProgressBar segments={getSegments ? getSegments(item, index) : item.segments} />
        </Box>
      ))}
    </>
  );
};

DiscreteProgressBarGroup.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.node,
      segments: PropTypes.arrayOf(
        PropTypes.shape({
          color: PropTypes.string.isRequired,
          value: PropTypes.number.isRequired,
          tooltip: PropTypes.string,
        }),
      ),
    }),
  ).isRequired,
  getSegments: PropTypes.func,
};


export { DiscreteProgressBarGroup };
